// namespace Constants {
    export const Attributes = {
        InstanceId: 'data-cb-instance',
        Context: 'data-edit-context',
        ContentBlockId: 'data-cb-id',
    };
// }
